var productName = 'schedulerpro';// region Symlinks ("grunt symlink" task)
export * from './webpack.core.entry.thin.js';
export * from './webpack.grid.entry.thin.js';
export * from './webpack.scheduler.entry.thin.js';
export * from './webpack.engine.entry.js';
// endregion
//region Thin bundle
export * from './webpack.entry.thin.js';
//endregion
// region Class renaming
export {
    // feature
    GroupSummary as GridGroupSummary,
    Summary as GridSummary,
    // export feature
    MultiPageExporter as GridMultiPageExporter,
    MultiPageVerticalExporter as GridMultiPageVerticalExporter,
    PdfExport as GridPdfExport,
    SinglePageExporter as GridSinglePageExporter,
    // feature experimental
    ExcelExporter as GridExcelExporter
} from './webpack.grid.entry.thin.js';
export {
    // features
    GroupSummary,
    Summary,
    // export feature
    MultiPageExporter,
    MultiPageVerticalExporter,
    PdfExport,
    SinglePageExporter,
    // features experimental
    ExcelExporter,
    // data
    AssignmentStore as SchedulerAssignmentStore,
    DependencyStore as SchedulerDependencyStore,
    EventStore as SchedulerEventStore,
    ResourceStore as SchedulerResourceStore,
    // data mixin
    PartOfProject as SchedulerPartOfProject,
    ProjectCrudManager as SchedulerProjectCrudManager,
    // feature
    DependencyEdit as SchedulerDependencyEdit,
    EventResize as SchedulerEventResize,
    // model
    AssignmentModel as SchedulerAssignmentModel,
    DependencyModel as SchedulerDependencyModel,
    EventModel as SchedulerEventModel,
    ProjectModel as SchedulerProjectModel,
    ResourceModel as SchedulerResourceModel
} from './webpack.scheduler.entry.thin.js';
export {
    // data
    AssignmentStore,
    DependencyStore,
    EventStore,
    ResourceStore,
    // data mixin
    PartOfProject,
    ProjectCrudManager,
    // feature
    DependencyEdit,
    EventResize,
    // model
    AssignmentModel,
    DependencyModel,
    EventModel,
    ProjectModel,
    ResourceModel
} from './webpack.entry.thin.js';
// endregion
